import _ from 'lodash';

export const openGoogleMapsPin = (lat?: string, lng?: string) => {
  // TODO link da migliorare
  if (!_.isNil(lat) && !_.isNil(lng)) {
    window.open(`https://maps.google.com/maps?q=${lat},${lng}`, '_blank');
  }
};
